import React, { forwardRef } from 'react';

import { cn } from '../../../lib/css/className/className';
import { ButtonProps, Button } from '../../Button';
import { TableCell } from '../Cell/Cell';
import { TableRow } from '../Row/Row';

import { i18n } from './Button.i18n';

import './Button.css';

const cls = cn('TableButton');

export type TableButtonProps = Omit<ButtonProps, 'size' | 'color'>;

const defaultChildren = i18n('Добавить');

export const TableButton = forwardRef<HTMLButtonElement, TableButtonProps>(function TableButton(
    { className, children = defaultChildren, ...props },
    ref,
) {
    return (
        <TableRow className={cls('row')}>
            <TableCell className={cls('cell')} colspan={100}>
                <Button
                    className={cls('button', [className])}
                    width="max"
                    size="m"
                    color="contrast"
                    {...props}
                    ref={ref}
                >
                    {children}
                </Button>
            </TableCell>
        </TableRow>
    );
});
